module.exports = __webpack_public_path__ + "static/snake-plant-0-fbffb5ea80803b29529421af72c933fe.png";